<script setup lang="ts">
import { computed, inject } from "vue";
import { nameInjectionKey } from "../keys";
import { ValidationArgs, useVuelidate } from "@vuelidate/core";

const props = withDefaults(defineProps<{
    modelValue: string | number | null,
    options: (string | {value: string | number, label: string}) []
    placeholder: string | undefined
    percentage?: boolean
    col?: string,
    inputClass?: string,
    inputContainer?: string,
    error?: boolean,
    id?: string
    validation?: ValidationArgs,
    hidePii?: boolean,
}>(), {
    percentage: false,
    col: "col-md-6 col-sm-12",
    inputClass: "",
    inputContainer: "",
    error: false,
    id: undefined,
    validation: undefined,
    hidePii: true,
});

const internalModelValue = computed(() => props.modelValue);

const v$ = useVuelidate({
    field: props.validation ?? {},
}, {
    field: internalModelValue,
});

defineEmits<{
    (on:"update:modelValue", value: string): void
}>();

const name = inject(nameInjectionKey);
if (typeof name !== "string") {
    throw new Error();
}
</script>

<template>
    <div :class="col">
        <div :class="percentage ? 'input-group input-wrapper': ''">
            <div :class="inputContainer">
                <select
                    :id="id || name"
                    class="form-select form-control"
                    :value="modelValue"
                    :class="[
                        {'errorfield': v$.$error || error },
                        {'sessioncamhidetext': hidePii },
                        inputClass,
                    ]"
                    @input="[$emit('update:modelValue', ($event.target as HTMLInputElement).value), v$.$touch()]"
                >
                    <option
                        v-if="(typeof placeholder !== 'undefined')"
                        value=""
                        disabled="true"
                        selected="true"
                        hidden="true"
                    >
                        {{ placeholder }}
                    </option>
                    <option
                        v-for="option in options"
                        :key="typeof option === 'string' ? option : option.label"
                        :value="typeof option === 'string' ? option : option.value"
                    >
                        {{ typeof option === 'string' ? option : option.label }}
                    </option>
                </select>
            </div>
            <span
                v-if="percentage"
                class="input-group-text"
            >%</span>
        </div>
        <div
            v-if="v$.$error"
            class="field-validation-error"
        >
            <div class="alert alert-danger">
                {{ v$.$errors[0].$message }}
            </div>
        </div>
    </div>
</template>
